import React, { useState } from 'react';
import { CheckIcon, ChevronRightIcon, TrendingUpIcon } from 'lucide-react';
const recommendations = [{
  room: 'Deluxe King',
  dates: '12–14 Jul',
  current: '€780',
  recommended: '€860',
  lift: '+€14.8K',
  reason: 'Couture Week compression'
}, {
  room: 'Junior Suite',
  dates: '18 Jul',
  current: '€1,120',
  recommended: '€1,190',
  lift: '+€5.2K',
  reason: 'Pickup 18% above pace'
}, {
  room: 'Terrace Suite',
  dates: '22–24 Jul',
  current: '€1,680',
  recommended: '€1,620',
  lift: '+€7.1K',
  reason: 'Protect suite conversion'
}];
export function PricingRecommendations() {
  const [applied, setApplied] = useState<string[]>([]);
  const applyRate = (room: string) => setApplied(current => [...current, room]);
  return <section aria-labelledby="pricing-title" className="border border-[#d8d2c6] bg-[#fffcf7]" data-id="element-109">
      <div className="flex items-start justify-between border-b border-[#ded8cc] p-4 sm:p-5" data-id="element-110">
        <div data-id="element-111">
          <h2 id="pricing-title" className="font-serif text-xl text-[#0b2032]" data-id="element-112">
            Rate recommendations
          </h2>
          <p className="mt-1 text-xs text-[#73766f]" data-id="element-113">
            3 actions · €27.1K projected uplift
          </p>
        </div>
        <span className="flex items-center gap-1 bg-[#edf3ee] px-2 py-1 text-[10px] font-bold uppercase tracking-wide text-[#34705c]" data-id="element-114">
          <TrendingUpIcon size={12} data-id="element-115" /> High confidence
        </span>
      </div>
      <div className="divide-y divide-[#e4ded4]" data-id="element-116">
        {recommendations.map(item => {
        const isApplied = applied.includes(item.room);
        return <article key={item.room} className="p-4" data-id="element-117">
              <div className="flex items-start justify-between gap-3" data-id="element-118">
                <div data-id="element-119">
                  <h3 className="text-sm font-semibold text-[#132b3d]" data-id="element-120">
                    {item.room}
                  </h3>
                  <p className="mt-0.5 text-[10px] text-[#7e7b73]" data-id="element-121">
                    {item.dates} · {item.reason}
                  </p>
                </div>
                <p className="text-xs font-semibold text-[#34705c]" data-id="element-122">
                  {item.lift}
                </p>
              </div>
              <div className="mt-3 flex items-center gap-2" data-id="element-123">
                <span className="text-xs text-[#86847c] line-through" data-id="element-124">
                  {item.current}
                </span>
                <ChevronRightIcon size={13} className="text-[#b6afa2]" data-id="element-125" />
                <span className="font-serif text-lg text-[#0b2032]" data-id="element-126">
                  {item.recommended}
                </span>
                <button type="button" disabled={isApplied} onClick={() => applyRate(item.room)} className={`ml-auto min-w-[82px] border px-3 py-1.5 text-[10px] font-bold uppercase tracking-wider transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#aa8649] disabled:cursor-default ${isApplied ? 'border-[#9db2a8] bg-[#edf3ee] text-[#34705c]' : 'border-[#0b2032] bg-[#0b2032] text-white hover:bg-[#17374e]'}`} data-id="element-127">
                  {isApplied ? <span className="flex items-center justify-center gap-1" data-id="element-128">
                      <CheckIcon size={12} data-id="element-129" /> Applied
                    </span> : 'Apply rate'}
                </button>
              </div>
            </article>;
      })}
      </div>
    </section>;
}